import { NAMES } from '@/utilities/constants'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import styles from './BlogHeader.module.scss'

const TYPING_SPEED = 150
const DELETE_SPEED = 100
const PAUSE_DURATION = 1000

export default function EntryHeader({ image, pageFields, formattedDate, disableOverlay }) {
  const { innerHeroFields } = pageFields || {}
  const { content, eyebrowText } = innerHeroFields || {}
  const isWorkPage = pageFields?.title === 'Work'

  const [displayedName, setDisplayedName] = useState('')
  const [nameIndex, setNameIndex] = useState(0)
  const [isTyping, setIsTyping] = useState(true)

  useEffect(() => {
    if (isWorkPage) return

    const currentName = NAMES[nameIndex]
    let timeoutId

    const updateDisplayedName = () => {
      if (isTyping) {
        if (displayedName === currentName) {
          timeoutId = setTimeout(() => setIsTyping(false), PAUSE_DURATION)
          return
        }
        setDisplayedName(currentName.slice(0, displayedName.length + 1))
      } else {
        if (displayedName === '') {
          setNameIndex((prev) => (prev + 1) % NAMES.length)
          setIsTyping(true)
          return
        }
        setDisplayedName(displayedName.slice(0, -1))
      }
    }

    const intervalId = setInterval(updateDisplayedName, isTyping ? TYPING_SPEED : DELETE_SPEED)

    return () => {
      clearInterval(intervalId)
      clearTimeout(timeoutId)
    }
  }, [displayedName, nameIndex, isTyping, isWorkPage])

  const headingPrefix = isWorkPage ? 'Check out some of our latest projects' : 'Industry insights from '

  return (
    <div className={styles.entryHeader}>
      {image?.sourceUrl ? (
        <Image src={image.sourceUrl} alt={image.altText || ''} fill sizes="100vw" style={{ objectFit: 'cover', zIndex: -3 }} priority />
      ) : null}
      {!disableOverlay && <div className={styles.overlay} />}

      <div className={styles.contentContainer} data-aos="fade-up">
        {eyebrowText && (
          <p className="eyebrow-text" style={{ color: 'white' }}>
            {eyebrowText}
          </p>
        )}

        <h1 className={styles.title} data-cy="page-main-heading">
          {headingPrefix}
          {displayedName}
          <span className={styles.dynamicName}>
            {!isWorkPage && (
              <span className={styles.cursor}>
                <span className={styles.cursorChar}>|</span>
              </span>
            )}
          </span>
        </h1>

        {formattedDate && <p className={styles.date}>{formattedDate}</p>}
        {content && <p className={styles.content}>{content}</p>}
      </div>
    </div>
  )
}
